import Cookies from 'js-cookie';

export const checkRoomIdValid = (roomId) => {
  const id = Cookies.get('roomId') || '';
  if(roomId === id) {
    return true;
  }
  return false;
}